import { render } from "./FooterVue.vue?vue&type=template&id=43cc85c5&scoped=true"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"

import "./FooterVue.vue?vue&type=style&index=0&id=43cc85c5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/server/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cc85c5"]])

export default __exports__